import * as React from 'react';
import {defaults} from 'lodash';
import {getSurfaceBox, useOverlay} from './OverlayContext';

type OverlayBoxProps = React.ComponentProps<'div'>;

// Renders an absolutely positioned div that fills the whole overlay
// as defined on the context.
export const OverlayBox = ({style, ...props}: OverlayBoxProps) => {
  const context = useOverlay();
  const box = getSurfaceBox(context);
  return (
    <div {...props} style={defaults({position: 'absolute'}, style, box)} />
  );
};

OverlayBox.displayName = 'OverlayBox';
